var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectChevron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17422 0.5C0.319868 0.5 -0.141042 1.50212 0.414964 2.15079L4.24074 6.6142C4.63984 7.07981 5.36016 7.07981 5.75926 6.6142L9.58504 2.15079C10.141 1.50212 9.68013 0.5 8.82578 0.5H1.17422Z",
    fill: "#A12885"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/select-chevron.2fa67c67b4a71561b4eb77ed8dd652b6.svg";